import { OperatorLogsEntityService } from '@views/pages/apps/superuser/operator-logs/services/operator-logs-entity.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, first, tap, take } from 'rxjs/operators';

@Injectable()
export class OperatorLogResolver implements Resolve<boolean> {

    constructor(private operatorLogsEntityService: OperatorLogsEntityService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.operatorLogsEntityService.loaded$.pipe(
          tap(loaded =>  {
            if(!loaded) {
              this.operatorLogsEntityService.getAll().pipe(
                take(1)
              );
            }
          }),
          filter(loaded => !!loaded),
          first()
        );
    }
}
